import React from 'react'
import PropTypes from 'prop-types'
import P from '../../Typography/P'
import dictionary from '../../../../dictionary'

import styles from '../radio-group.module.scss'
import LegendsRadioGroup from '../LegendsRadioGroup'
import LegendsTooltip from '../LegendsTooltip'

function PhoneCases(props) {
  const { name, content: allContent, onChange, current } = props
  const softTouchContent = allContent.filter(({ value }) =>
    value.includes(`soft_touch`)
  )
  const leatherContent = allContent.filter(({ value }) =>
    value.includes(`leather`)
  )
  const siliconeContent = allContent.filter(({ value }) =>
    value.includes(`silicone`)
  )
  return [
    { legend: `Soft touch`, content: softTouchContent },
    { legend: `Кожа`, content: leatherContent },
    { legend: `Силикон`, content: siliconeContent },
  ].map(
    ({ legend, content }) =>
      content.length > 0 && (
        <div key={legend} className={styles.root}>
          <P size="small" className={styles.legend}>
            {legend}
          </P>
          <LegendsRadioGroup
            defaultValue={current}
            value={current}
            ariaLabel={name}
            className={styles.group}
            onChange={(value) => onChange(name, value)}
          >
            {content.map(({ value, label, disabled }) => (
              <LegendsTooltip
                key={`${name}-${value}`}
                title={dictionary.item[value]}
                disabled={disabled}
              >
                <span
                  disabled={disabled}
                  className={styles.labelImage}
                  style={{ backgroundImage: `url(${label})` }}
                />
              </LegendsTooltip>
            ))}
          </LegendsRadioGroup>
        </div>
      )
  )
}

PhoneCases.propTypes = {
  productName: PropTypes.string,
  department: PropTypes.string,
  category: PropTypes.string,
  name: PropTypes.string,
  content: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
      difference: PropTypes.number,
    })
  ),
  current: PropTypes.string,
  onChange: PropTypes.func,
}

export default PhoneCases
